/* eslint-disable camelcase */

import {
    SET_IS_FETCHING_PICKERS,
    SET_PICKER_EXCLUDED,
    SET_PICKERS,
    SET_PICKERS_ALL_CHUNKS_LOADED,
    SET_PICKERS_LOADED_CHUNK_INDEXES,
    SET_PICKERS_TOTAL,
    SET_PICKERS_TOTAL_CHUNKS,
} from 'reducers/actions-types';

export default function pickersReducer(state = {
    items: [],

    loadedChunkIndexes: [],
    loadedAllChunks: false,
    totalChunks: 0,
    chunkSize: 100,

    total: null,
    isFetching: false,
}, { type, isFetching, items, person_id, excluded, total, loadedChunkIndexes, totalChunks, loadedAllChunks }) {
    let picker;
    let pickerIndex;
    switch (type) {
        case SET_IS_FETCHING_PICKERS:
            return Object.assign({}, state, {
                isFetching,
            });
        case SET_PICKERS_LOADED_CHUNK_INDEXES:
            return Object.assign({}, state, {
                loadedChunkIndexes,
            });
        case SET_PICKERS_TOTAL_CHUNKS:
            return Object.assign({}, state, {
                totalChunks,
            });
        case SET_PICKERS_ALL_CHUNKS_LOADED:
            return Object.assign({}, state, {
                loadedAllChunks,
            });
        case SET_PICKERS_TOTAL:
            return Object.assign({}, state, {
                total,
            });
        case SET_PICKER_EXCLUDED:
            picker = state.items.find(item => item.person_id === person_id); // eslint-disable-line camelcase
            pickerIndex = state.items.indexOf(picker);

            if (!~pickerIndex) {
                return state;
            }

            picker = Object.assign({}, picker, { excluded });

            items = state.items.slice();
            items.splice(pickerIndex, 1, picker);

            return Object.assign({}, state, { items });
        case SET_PICKERS:
            return Object.assign({}, state, {
                items: [...items],
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/pickers/index.js